import AdFormService from '../services/AdFormService';
import PageData from '../PageData';
import Modal from './modals/Modal';
import FormValidations from '../forms/validator/FormValidations';
import {surveyOnDuplicatedLeadOn} from '../services/DuplicatedLeadSurveyService';
import LeadTrackingService from '../services/LeadTrackingService';
import {getChatSectionIdsMap, getChatSectionsMap} from '../ChatSections';
import {Brand} from '../types/Brand';
import {Device} from '../types/Device';
import SocialTab from './tabs/SocialTab';
import {FormActions} from '../forms/FormActions';
import {Section} from '../services/Section';
import ContactModal from './modals/ContactModal';
import UserData from "../UserData";
import UserContactDataStorageService from "../services/UserContactDataStorageService";
import {OpenSocialNetworkEvent} from "../events/Events";
import {EventBus} from "../events/EventBus";

export default class ChatOptions {
  private readonly pageData: PageData;

  private readonly emailInquiryModal: Modal;

  private readonly nameInput: HTMLInputElement;
  private readonly nameError: HTMLSpanElement;

  private readonly emailInput: HTMLInputElement;
  private readonly emailError: HTMLSpanElement;

  private readonly phoneInput: HTMLInputElement;
  private readonly phoneError: HTMLSpanElement;

  private readonly submitEmailButton: HTMLButtonElement;

  private readonly multipleSocialNetworkWhatsapp: HTMLElement;

  private readonly multipleSocialNetworkLine: HTMLElement;

  private readonly multipleSocialNetworkViber: HTMLElement;

  private readonly multipleSocialNetworkFacebook: HTMLElement;

  private readonly multipleSocialNetworkSkype: HTMLElement;

  private chatButtonOpenTrigger: HTMLElement[] | undefined;

  private buttonPressedId: string | undefined;

  private readonly originalEmailEnquiryMessage: string;

  private buttonsDataMap!: Map<string, { section: string; name: string; }>;

  private obfuscatedContactElements: Array<HTMLElement> = [];

  private readonly buttonsSections= getChatSectionIdsMap();

  private readonly socialTabButtonsIds = [
    'social-tab-list-whatsapp',
    'social-tab-list-line',
    'social-tab-list-messenger',
    'social-tab-list-viber',
    'social-tab-list-skype',
    'social-tab-list-whatsapp-obfuscated',
    'social-tab-list-viber-obfuscated',
    'social-tab-list-line-obfuscated',

  ];

  private constructor(params: { emailInquiryModal: Modal, pageData: PageData }) {
    this.emailInquiryModal = params.emailInquiryModal;
    this.pageData = params.pageData;

    this.multipleSocialNetworkWhatsapp = document.getElementById('social-tab-list-whatsapp')!;
    this.multipleSocialNetworkLine = document.getElementById('social-tab-list-line')!;
    this.multipleSocialNetworkFacebook = document.getElementById('social-tab-list-messenger')!;
    this.multipleSocialNetworkViber = document.getElementById('social-tab-list-viber')!;
    this.multipleSocialNetworkSkype = document.getElementById('social-tab-list-skype')!;

    this.nameInput = document.getElementById('name-input-chat-options') as HTMLInputElement;
    this.nameError = document.getElementById('name-error-chat-options') as HTMLSpanElement;
    this.emailInput = document.getElementById('email-input-chat-options') as HTMLInputElement;
    this.emailError = document.getElementById('email-error-chat-options') as HTMLSpanElement;
    this.phoneInput = document.getElementById('phone-input-chat-options') as HTMLInputElement;
    this.phoneError = document.getElementById('phone-error-chat-options') as HTMLSpanElement;
    this.submitEmailButton = document.getElementById('submit-button-chat-options') as HTMLButtonElement;
    let originalEmailEnquiry = document.getElementById('email-inquiry-modal-message');
    this.originalEmailEnquiryMessage = originalEmailEnquiry != null ? originalEmailEnquiry.innerText : ""
    this.retrieveObfuscatedContactElements();
    this.buttonsDataMap = getChatSectionsMap();
    this.createMapForObfuscatedContactElements();

    this.socialTabButtonsIds.forEach((element) => {
      const htmlElement = document.getElementById(element);
      if (htmlElement) {
        htmlElement.addEventListener('click', () => {
          this.showEmailForm(htmlElement.id);
        });
      }
    });

    new UserContactDataStorageService().fillInputsWithStoredValues(
        { input: this.nameInput, type: 'name' },
        { input: this.emailInput, type: 'email' },
        { input: this.phoneInput, type: 'phone' },
    );
  }

  static init = (pageData: PageData) => {
    return ChatOptions.setup(pageData, ChatOptions.isNestoriaMobile(pageData));
  };

  private static setup = (pageData: PageData, isNestoriaMobile: boolean) => {
    let openTrigger;
    const chatOptions = new ChatOptions({
      emailInquiryModal: new Modal({
        pageData,
        element: document.getElementById('email-inquiry-modal-chat-options')!,
        openTrigger,
        closeTrigger: document.getElementById('close-email-inquiry-modal-chat-options')!,
        isNestoriaMobile,
      }),
      pageData,
    });
    chatOptions.setupEventListeners();
    return chatOptions;
  };

  private setupEventListeners = () => {
    this.emailInquiryModal.onOpen = this.onOpen;
    this.emailInquiryModal.onClose = this.onClose;
    if (this.phoneInput) this.phoneInput.addEventListener('keyup', this.validatePhone);
    if (this.submitEmailButton) this.submitEmailButton.addEventListener('click', this.openSocialNetwork);
    if (this.multipleSocialNetworkWhatsapp) this.multipleSocialNetworkWhatsapp.addEventListener('click', this.openSocialNetwork);
    if (this.multipleSocialNetworkLine) this.multipleSocialNetworkLine.addEventListener('click', this.openSocialNetwork);
    if (this.multipleSocialNetworkFacebook) this.multipleSocialNetworkFacebook.addEventListener('click', this.openSocialNetwork);
    if (this.multipleSocialNetworkViber) this.multipleSocialNetworkViber.addEventListener('click', this.openSocialNetwork);
    if (this.multipleSocialNetworkSkype) this.multipleSocialNetworkSkype.addEventListener('click', this.openSocialNetwork);

    this.createOpenTriggersForSocialButtons();
  };

  public retrieveObfuscatedContactElements = () => {
    this.obfuscatedContactElements = Array.from(document.querySelectorAll('[id^="obfuscated_content_"]'));
  };

  private concatChatAndObfuscatedChatElementsMaps = (buttonsDataMap: Map<string, { section: string; name: string; }>) => {
    this.obfuscatedContactElements.forEach((element) => {
      if (element.id.includes('whatsapp')) buttonsDataMap.set(element.id, { section: Section.SECTION_ADPAGE_DESCRIPTION_WHATSAPP, name: 'Whatsapp' });
      if (element.id.includes('viber')) buttonsDataMap.set(element.id, { section: Section.SECTION_ADPAGE_DESCRIPTION_VIBER, name: 'Viber' });
      if (element.id.includes('line')) buttonsDataMap.set(element.id, { section: Section.SECTION_ADPAGE_DESCRIPTION_LINE, name: 'Line' });
    });
  };

  private createMapForObfuscatedContactElements = () => {
    if(!ChatOptions.isNestoriaMobile(this.pageData)){
      this.concatChatAndObfuscatedChatElementsMaps(this.buttonsDataMap);
      this.createObfuscatedEmailElementEvent();
    }
  };

  private createObfuscatedEmailElementEvent = () => {
    const obfuscatedEmailContactElement = [...this.obfuscatedContactElements].filter((element) => element.id.includes('email') || element.id.includes('url'));
    obfuscatedEmailContactElement.forEach((element) => {
      if (this.pageData.device === Device.MOBILE || !this.pageData.isBoosted) {
        ContactModal.setup(this.pageData);
      } else if (this.pageData.isBoosted) {
        element.addEventListener('click', (event) => {
          event.stopImmediatePropagation();
          new FormActions(this.pageData).highlightForm(Section.SECTION_ADPAGE_DESCRIPTION_INFO);
        });
      }
    });
  };

  private createOpenTriggersForSocialButtons = () => {
    this.chatButtonOpenTrigger = ChatOptions.constructOpenTrigger(this.pageData.chatsData.socialNetworks, this.pageData.brand, this.pageData.device);
    if (this.chatButtonOpenTrigger) {
      this.chatButtonOpenTrigger.forEach((value) => {
        if (value && !value.id.includes('email') && !value.id.includes('url')) value.addEventListener('click', (event) => this.chatButtonClicked(value.id, event));
      });
    }
  };

  public chatButtonClicked = (id: string | undefined, event: Event) => {
      this.buttonPressedId = id;
      if (this.clickedFromSocialTab(this.buttonPressedId as string)) return;
      if (!(this.isWhatsappTabClicked(this.buttonPressedId as string)
              || this.isWhatsappTabListClicked(this.buttonPressedId as string))
          && ChatOptions.isNestoriaMobile(this.pageData)) return;
      if (this.buttonPressedId !== undefined && this.buttonPressedId !== '') {
          const chatButton = document.getElementById(this.buttonPressedId) as HTMLButtonElement;
          const sectionNameFromElement: string | undefined = chatButton.dataset.section;
          const sectionTypeFromElement: string | undefined = chatButton.dataset.sectionType;
          const chatSection = sectionNameFromElement && sectionTypeFromElement ?
              {section: sectionNameFromElement, name: sectionTypeFromElement} :
              this.buttonsDataMap.get(this.buttonPressedId);
          if (chatSection !== undefined) {
              const sectionName = chatSection.section;
              const sectionId = this.buttonsSections.get(sectionName);
              const chatName = chatSection.name;
              if (sectionId !== undefined && chatName !== undefined && chatName === 'Whatsapp') {
                  new LeadTrackingService(this.pageData).getWhatsappData(sectionId)
                      .then((chatResponse) => {
                          if (chatResponse.status === 200) {
                              let fromProject = false;
                              if (chatButton) {
                                  const fromProjectFromElement = chatButton.dataset.project;
                                  if (fromProjectFromElement)
                                      fromProject = fromProjectFromElement.toLowerCase() === 'true'
                              }
                              this.applyImpressionChatOptionSelected(id as string, sectionName, fromProject);
                              chatResponse.json().then((chatResponseJson) => {
                                  const {url} = chatResponseJson.data;
                                  if (this.pageData.device === 'DESKTOP') {
                                      const chatTargetAnchor = document.createElement('a');
                                      chatTargetAnchor.target = '_blank';
                                      chatTargetAnchor.href = url;
                                      chatTargetAnchor.click();
                                  } else {
                                      document.location.href = url;
                                  }
                              });
                          } else {
                              this.showEmailForm(id);
                          }
                      }).catch(() => {
                      this.showEmailForm(id);
                  });
              } else {
                  this.showEmailForm(id);
              }
          }
      }
  };

    private onOpen = (id: string | undefined) => {
        new UserContactDataStorageService().fillInputsWithStoredValues(
            {input: this.nameInput, type: 'name'},
            {input: this.emailInput, type: 'email'},
            {input: this.phoneInput, type: 'phone'}
        );
        if (id !== undefined) {
            this.buttonPressedId = id;
            let sectionToSend = "";
            let fromProject = false;
            const chatButton = document.getElementById(this.buttonPressedId) as HTMLButtonElement;
            if (chatButton) {

                const sectionIdFromElement: string | undefined = chatButton.dataset.section;
                if (sectionIdFromElement) {
                    sectionToSend = sectionIdFromElement
                }
                const fromProjectFromElement = chatButton.dataset.project;
                if (fromProjectFromElement)
                    fromProject = fromProjectFromElement.toLowerCase() === 'true';
            }
            this.updateEmailInquiryMessageWithProperSocialNetwork(id);
            this.applyImpressionChatOptionSelected(id, sectionToSend, fromProject);
        }
    };

  private showEmailForm = (id: string | undefined) => {
    if (this.pageData.viewWhatsappPhoneModalField && this.pageData.viewWhatsappPhoneModalField == "phone") {
      this.phoneInput.classList.remove('invalid');
    }
    else {
      this.emailInput.classList.remove('invalid');
    }
    if (id !== undefined) {
      this.updateEmailInquiryMessageWithProperSocialNetwork(id);
    }
    if (!ChatOptions.isNestoriaMobile(this.pageData)) {
      this.emailInquiryModal.open(id)();
    } else if (id?.substring(0, 10) === 'social-tab') {
      new SocialTab(this.pageData).showSocialTabContactFormForButton(id);
    }
  };

  private resetFormErrors = () => {
    this.removeError(this.nameError, this.nameInput);
    this.removeError(this.emailError, this.emailInput);
    this.removeError(this.phoneError, this.phoneInput);
  };

  private onClose = () => {
    this.resetFormErrors();
    this.setOriginalEmailEnquiryMessage();
  };

  private showError = (errorText: HTMLSpanElement, input: HTMLInputElement, onShowErrorMessage: ((errorText: HTMLSpanElement) => void) = () => {}) => {
    if (errorText) {
      onShowErrorMessage(errorText);
      errorText.classList.add('active');
    }
    if (input) input.classList.add('invalid');
  };

  private removeError = (errorText: HTMLSpanElement, input: HTMLInputElement) => {
    if (errorText) errorText.classList.remove('active');
    if (input) input.classList.remove('invalid');
  };

  private hasErrorActive = (input: HTMLInputElement, errorText: HTMLSpanElement) => {
    let hasError = false;
    if (errorText) hasError = errorText.classList.contains('active');
    if (input) hasError = input.classList.contains('invalid');
    return hasError;
  };

  private handleError = (isValid: boolean, errorText: HTMLSpanElement, input: HTMLInputElement, hasMultipleErrorMessages: boolean = false, onShowErrorMessage: ((errorText: HTMLSpanElement) => void) = () => {}) => {
    const hasActiveError = this.hasErrorActive(input, errorText);
    if (isValid) {
      if (hasActiveError) this.removeError(errorText, input);
    } else if (!hasActiveError || hasMultipleErrorMessages) {
      this.showError(errorText, input, onShowErrorMessage);
    }
  };

  private validateName = () => {
    const existsNameInput = this.nameInput !== null;
    if (existsNameInput) {
      const isValid = FormValidations.isNotEmpty(this.nameInput.value);
      this.handleError(isValid, this.nameError, this.nameInput);
      return isValid;
    }

    return true;
  };

  private validateEmail = () => {
    const existsEmailInput = this.emailInput !== null;
    if (existsEmailInput) {
      const isValid = FormValidations.isNotEmpty(this.emailInput.value) && FormValidations.emailIsValid(this.emailInput.value);
      this.handleError(isValid, this.emailError, this.emailInput);
      return isValid;
    }

    return true;
  };

  private validatePhone = () => {
    const existsPhoneInput = this.phoneInput !== null;
    if (existsPhoneInput) {
      const isEmpty = FormValidations.isEmpty(this.phoneInput.value);
      const isValidPhone = FormValidations.isValidPhone(this.phoneInput.value);
      const isValid = !isEmpty && isValidPhone;
      this.handleError(isValid, this.phoneError, this.phoneInput, this.hasMultipleErrorMessages(), this.onShowPhoneErrorMessage(isEmpty, isValidPhone));
      return isValid;
    }

    return true;
  };

  private onShowPhoneErrorMessage(isEmpty: boolean, isValidPhone: boolean) {
    if (this.hasMultipleErrorMessages()) {
      let errorMessage = this.getPhoneErrorMessageToShow(isEmpty, isValidPhone);
      return (errorText: HTMLSpanElement) => {
        errorText.innerHTML = errorMessage
      };
    } else {
      return () => {};
    }
  }

  private getPhoneErrorMessageToShow(isEmpty: boolean, isValidPhone: boolean) {
    if (isEmpty && this.pageData.validation?.errorMessages.phone.empty !== undefined) {
      return this.pageData.validation.errorMessages.phone.empty;
    } else if (!isValidPhone && this.pageData.validation?.errorMessages.phone.incorrectFormat !== undefined) {
      return  this.pageData.validation.errorMessages.phone.incorrectFormat;
    }
    return '';
  }

  private hasMultipleErrorMessages() {
    return this.pageData.validation && this.pageData.validation.hasMultipleErrorMessages;
  }

  private validateInputs = () => {
    const isNameValid = this.validateName();
    const isEmailValid = this.validateEmail();
    const isPhoneValid = this.validatePhone();

    return isNameValid && isEmailValid && isPhoneValid;
  };

  public openSocialNetwork = (event: Event) => {
    let fieldValue = "";
    const storage = new UserContactDataStorageService();
    if (this.nameInput && this.nameInput.value) {
      storage.storeUserInputValue(this.nameInput, 'name');
    }

    if (this.phoneInput && this.phoneInput.value) {
      storage.storeUserInputValue(this.phoneInput, 'phone');
      fieldValue = this.phoneInput.value;
    }

    if (this.emailInput && this.emailInput.value) {
      storage.storeUserInputValue(this.emailInput, 'email');
      fieldValue = this.emailInput.value;
    }

    event.stopImmediatePropagation();
    this.theLeadHasBeenSent();
    const clickedButtonId = ChatOptions.isNestoriaMobile(this.pageData) ? (event.currentTarget as HTMLElement).id : this.buttonPressedId as string;
    if (this.clickedFromSocialTab(clickedButtonId)) return;

    const isFormValid = this.validateInputs();
    if (!isFormValid) return;

    if (!(ChatOptions.isNestoriaMobile(this.pageData))) {
      this.emailInquiryModal!.close();
    }

    if (clickedButtonId !== undefined && clickedButtonId !== '') {
      this.setOriginalEmailEnquiryMessage();
      const element = document.getElementById(clickedButtonId.replace('-description', '')) as HTMLButtonElement;
      if (element && element.value !== '') {
        surveyOnDuplicatedLeadOn(this.pageData, 'chat');
        const win = window.open(element.value, '_blank');
        if (win) win.focus();
      }

      this.buttonsDataMap = getChatSectionsMap();
      this.concatChatAndObfuscatedChatElementsMaps(this.buttonsDataMap);
      this.applyChatOptionSelected(clickedButtonId, fieldValue);
      const eventBus = EventBus.getInstance();
      const socialNetworkSection: string = this.buttonsDataMap.get(clickedButtonId)?.section ?? '';
      const socialNetworkName: string = this.buttonsDataMap.get(clickedButtonId)?.name ?? '';

      eventBus.emit(new OpenSocialNetworkEvent({
        socialNetworkSection: socialNetworkSection,
        socialNetworkName: socialNetworkName,
      }));
    }
  };

  private static constructOpenTrigger = (socialNetworks: Array<string>, brand: string, device: string) : Array<HTMLElement> => {
    const openTriggerArray = new Array<HTMLElement>();
    if (brand === Brand.NESTORIA && device === Device.MOBILE) {
      socialNetworks.forEach((socialNetwork) => {
        if (socialNetwork === 'whatsapp') {
          openTriggerArray.push(document.getElementById('social-tab-whatsapp')!);
          openTriggerArray.push(document.getElementById('social-tab-list-whatsapp')!);
        }
      });
    } else {
      socialNetworks.forEach((socialNetwork) => {
        if (socialNetwork === 'whatsapp') {
          openTriggerArray.push(document.getElementById('button-chat-whatsapp-mobile')
            ? document.getElementById('button-chat-whatsapp-mobile')!
            : document.getElementById('button-chat-whatsapp-desktop')!);
        }
        if (socialNetwork === 'line') {
          openTriggerArray.push(document.getElementById('button-chat-line-mobile')
            ? document.getElementById('button-chat-line-mobile')!
            : document.getElementById('button-chat-line-desktop')!);
        }
        if (socialNetwork === 'skype') {
          openTriggerArray.push(document.getElementById('button-chat-skype-mobile')
            ? document.getElementById('button-chat-skype-mobile')!
            : document.getElementById('button-chat-skype-desktop')!);
        }
        if (socialNetwork === 'facebook') {
          openTriggerArray.push(document.getElementById('button-chat-messenger-mobile')
            ? document.getElementById('button-chat-messenger-mobile')!
            : document.getElementById('button-chat-messenger-desktop')!);
        }
        if (socialNetwork === 'viber') {
          openTriggerArray.push(document.getElementById('button-chat-viber-mobile')
            ? document.getElementById('button-chat-viber-mobile')!
            : document.getElementById('button-chat-viber-desktop')!);
        }
      });

      const obfuscatedContactElements = document.querySelectorAll('[id^="obfuscated_content_"]');

      obfuscatedContactElements.forEach((element) => {
        if(!element.id.includes("phone")){
          openTriggerArray.push(element as HTMLElement);
        }
      });

    }

    return openTriggerArray;
  };

  private updateEmailInquiryMessageWithProperSocialNetwork(buttonId: string) {
    const buttonIdData = this.buttonsDataMap.get(buttonId);
    if (buttonIdData !== undefined) {
      const emailInquiryMessageElement = document.getElementById('email-inquiry-modal-message')!;
      emailInquiryMessageElement.innerText = emailInquiryMessageElement.innerText.replace('{social_network}', buttonIdData.name);
    }
  }

  private setOriginalEmailEnquiryMessage() {
    const emailInquiryMessageElement = document.getElementById('email-inquiry-modal-message')!;
    emailInquiryMessageElement.innerText = this.originalEmailEnquiryMessage;
  }

    private applyImpressionChatOptionSelected(buttonId: string, sectionName: string, fromProject: boolean) {
        let sectionToSend = "";
        if (sectionName && sectionName.length > 0) {
            sectionToSend = sectionName;
        } else {
            const buttonIdData = this.buttonsDataMap.get(buttonId);
            if (buttonIdData) {
                sectionToSend = buttonIdData.section;
            }
        }
        new AdFormService().applyImpressionChatOptionDisplay(this.pageData, sectionToSend, 2, fromProject)
            .then(_ => {});
    }

  private getUserData = () : UserData => {
    const userData: UserData = {};
    if (this.emailInput && this.emailInput.value) userData.email = this.emailInput.value;
    if (this.nameInput && this.nameInput.value) userData.name = this.nameInput.value;
    if (this.phoneInput && this.phoneInput.value) userData.phone = this.phoneInput.value;
    return userData;
  };

    private applyChatOptionSelected(buttonId: string, userEmail: string) {
        let section = null;
        let fromProject = false;
        const chatButton = document.getElementById(buttonId) as HTMLButtonElement;
        if (chatButton) {
            const sectionFromElement = chatButton.dataset.section;
            if (sectionFromElement) {
                section = sectionFromElement;
            }
            const fromProjectFromElement = chatButton.dataset.project;
            if (fromProjectFromElement) {
                fromProject = fromProjectFromElement.toLowerCase() === 'true'
            }
        }
        if (!section) {
            if (buttonId.includes('obfuscated_content_viber')) {
                section = Section.SECTION_ADPAGE_DESCRIPTION_VIBER;
            } else if (buttonId.includes('obfuscated_content_line')) {
                section = Section.SECTION_ADPAGE_DESCRIPTION_LINE;
            } else {
                section = this.buttonsDataMap.get(buttonId)?.section
            }
        }
        const userData = this.getUserData();

        if (section !== null) {
            new AdFormService().applyChatOptionDisplay(this.pageData, section!, userData, undefined, fromProject)
                .then(_ => {
                });
        }
    }

  private clickedFromSocialTab = (elementId: string): boolean => {
    return this.socialTabButtonsIds.filter((item) => item === elementId).length > 0;
  };

  private static isNestoriaMobile = (pageData: PageData) => pageData.brand === Brand.NESTORIA && pageData.device === Device.MOBILE;

  private isWhatsappTabClicked = (elementId: string) => (document.getElementById(elementId) !== null && (document.getElementById(elementId)!.querySelector('.contact__tab-image') as HTMLElement)
        && (document.getElementById(elementId)!.querySelector('.contact__tab-image') as HTMLElement).dataset.social === 'whatsapp')
        || elementId.includes("obfuscated") && document.querySelectorAll('[id^="obfuscated_content_whatsapp"]').length > 0;

  private isWhatsappTabListClicked = (elementId: string) => (elementId === 'social-tab-list-whatsapp' && document.getElementById(elementId) !== undefined);

  private theLeadHasBeenSent = () => {
    (document.querySelector('meta[name="aLeadHasBeenSent"]') as HTMLMetaElement).content = 'true';
  };
}
